module.exports = __webpack_public_path__ + "img/scrum-psm1.de7866b0.png";